// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"401":"63a4645c","547":"e2d9922a","670":"2aa09cdc","788":"77e18b74","857":"192a0446","882":"9e082112","947":"d17d39f6"}[chunkId] + ".chunk.css";
};